module.exports = __webpack_public_path__ + "img/logo.eeed0dd2.png";